import { formatPhoneNumberForDisplay } from 'utils/phone';

import { WORKSHEET_FIELD_FORMAT } from '../../WorksheetFieldsLayout.constants';

const NOT_AMOUNT_CHARACTERS = /[^\d.]/g;

// While typing: an amount keeps digits and one decimal point; a phone is left as typed.
export const cleanWorksheetTextInput = ({ format, value }) => {
  if (format !== WORKSHEET_FIELD_FORMAT.CURRENCY) {
    return value;
  }

  const [whole, ...decimals] = String(value ?? '')
    .replace(NOT_AMOUNT_CHARACTERS, '')
    .split('.');

  return decimals.length ? `${whole}.${decimals.join('')}` : whole;
};

// On leaving the field: a US phone number is shown as (234) 567-8901; other values unchanged.
export const formatWorksheetTextValue = ({ format, value }) =>
  format === WORKSHEET_FIELD_FORMAT.PHONE && value ? formatPhoneNumberForDisplay(value) : value;
